import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView.ReportAccessDetailHeader`

export default defineMessages({
  allPrimaryCategoriesHeading: {
    id: `${scope}.allPrimaryCategoriesHeading`,
    defaultMessage: 'All {pluralPrimaryOrgCategoryLabel}',
  },
  allPrimaryCategoriesHelperText: {
    id: `${scope}.allPrimaryCategoriesHelperText`,
    defaultMessage:
      'Adding or removing users to all {pluralPrimaryOrgCategoryLabel} will give them access to every {singularSecondaryOrgCategoryLabel} in their spending reports.',
  },
  allSecondaryCategoriesHeading: {
    id: `${scope}.allSecondaryCategoriesHeading`,
    defaultMessage: 'All {pluralSecondaryOrgCategoryLabel}',
  },
  allSecondaryCategoriesHelperText: {
    id: `${scope}.allSecondaryCategoriesHelperText`,
    defaultMessage:
      'Adding users to all {pluralSecondaryOrgCategoryLabel} in {primaryCategoryName} will give them access to all {singularSecondaryOrgCategoryLabel} data in their spending reports.',
  },
  singleHelperText: {
    id: `${scope}.singleHelperText`,
    defaultMessage:
      'Users listed here will be able to view {secondaryCategoryName} data in their spending reports.',
  },
  superuserExclusionTooltip: {
    id: `${scope}.superuserExclusionTooltip`,
    defaultMessage:
      'Users with superuser permissions are excluded in this list.',
  },
  helpIconLabel: {
    id: `${scope}.helpIconLabel`,
    defaultMessage: 'More information',
  },
})
